<template>
    <div class="businessDetails-body-box">
        <div class="businessDetails-content-box" v-html="content"></div>

        <div class="businessDetails-list-box">
            <h1 class="newsDetail-t">— 版块相关企业 —</h1>
            <div class="contentUs-company-box transition businessDetails-list-content">
                <ul class="contentUs-company-list list-unstyled">
                    <li class="contentUs-company-item transition" v-for="item in Affiliates" :key="item">
                        <div class="contentUs-company-img-box banCopy">
                            <img :src="item.img_url" class="contentUs-company-img">
                        </div>
                        <div class="contentUs-company-content-body-box">
                            <div class="contentUs-company-content">
                                <h4 class="contentUs-company-name">{{ item.company }}</h4>
                                <ul class=" col-10 list-unstyled">
                                    <li>
                                        地址：{{ item.address }}
                                    </li>
                                    <li>
                                        电话：{{ item.telephone }}
                                    </li>
                                    <li>
                                        传真：{{ item.fax }}
                                    </li>
                                    <li>
                                        邮编：{{ item.zip_code }}
                                    </li>
                                    <li>
                                        邮箱：{{ item.email }}
                                    </li>
                                </ul>
                            </div>
                            <div class="contentUs-company-link-box banCopy">
                                <a class="contentUs-company-link" :href="item.website" target="_blank">前往官网</a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="list-group fixed-left d-none d-lg-block transition banCopy businessDetails-nav-item">
            <a class="list-group-item transition" v-for="(item, index) in navItem" :key="index"
                :class="{ active: isOverviewActive == index }" @click="changeActive(index)">{{ item }}</a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            getTitle: '',
            isOverviewActive: 0,
            navItem: ["新能源", "节能环保", "新材料", "生物医药", "人工智能", "产业服务"],
            content: '',
            Affiliates: [],
            id: '',
        }
    },
    methods: {
        changeActive(num) {
            this.isOverviewActive = num
            this.$router.push({
                name: 'businessDetails',
                query: {
                    title: this.navItem[num],
                }
            })
            this.Post("http://demoapi.hkjt.cn/pages/businessDetails.php?title=" + this.navItem[num])
        },
        loadData(navString) {
            for (var i = 0; i < this.navItem.length; i++) {
                if (navString == this.navItem[i]) {
                    this.isOverviewActive = i
                    break;
                }
            }
        },
        Post(url) {
            this.axios.get(url).then(res => {
                this.content = res.data[0]['content']
                if (this.id == '' || this.id != res.data[0]['company_id']) {
                    this.PostCompany("http://demoapi.hkjt.cn/pages/company.php?id=" + res.data[0]['company_id'])
                }
                this.id = res.data[0]['company_id']
            })
        },
        PostCompany(url) {
            this.axios.get(url).then(res => {
                this.Affiliates = res.data
                //console.log(this.Affiliates)
            })
        },
    },
    watch: {
        '$route': function (to, from) {
            if (to.query.title != from.query.title) {
                this.getTitle = to.query.title;
                this.loadData(to.query.title)
                this.Post("http://demoapi.hkjt.cn/pages/businessDetails.php?title=" + to.query.title)
                this.PostCompany("http://demoapi.hkjt.cn/pages/company.php?id=" + to.query.companyid)
            }
        }
    },
    mounted() {
        document.title="杭开集团-业务领域";

        this.getTitle = this.$route.query.title
        this.id = this.$route.query.companyid
        this.loadData(this.getTitle);
        this.Post("http://demoapi.hkjt.cn/pages/businessDetails.php?title=" + this.getTitle)
        // console.log(this.$route.query.companyid)
        this.PostCompany("http://demoapi.hkjt.cn/pages/company.php?id=" + this.id)
    },

}
</script>

<style scoped>
.businessDetails-nav-item {
    top: 40% !important;
}

.businessDetails-body-box {
    width: 100vw;
    margin: 13rem 0 5rem 0;
}

.businessDetails-content-box {
    width: 65rem;
    margin: 0 auto;
    transition-duration: 0.5s;
}

@media screen and (min-width:991px) {
    .businessDetails-content-box>p>strong>span {
        font-size: 1.7rem !important;
    }

    .businessDetails-content-box>p>span,
    .businessDetails-content-box>p>span>span {
        font-size: 1.3rem !important;
    }
}

@media screen and (max-width:991px) {
    .businessDetails-content-box>p>strong>span {
        font-size: 1.2rem !important;
    }

    .businessDetails-content-box>p>span,
    .businessDetails-content-box>p>span>span {
        font-size: 1rem !important;
    }
}


.newsDetail,
.newsDetail-t {
    padding-bottom: 40px;
    padding-top: 20px;
    text-align: center;
    color: #e8623e;
    font-weight: bold;
}

.businessDetails-list-content {
    margin: 0 auto;
}

@media screen and (max-width:1090px) {
    .businessDetails-content-box {
        width: 95%;
        transition-duration: 0.5s;
    }

    .businessDetails-body-box {
        margin: 5rem 0 5rem 0;
    }
}
</style>